import { type Room } from "matrix-js-sdk/src/matrix";

import { EchoContext } from "./EchoContext";

export class RoomEchoContext extends EchoContext {
    public constructor(public readonly room: Room) {
        super();
    }
}
